/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	technicianName: string;
	mediaBatchIdentifier: string;
}

const MBTechnicialVerificationCard: React.FC<Props> = ({ technicianName, mediaBatchIdentifier }) => {
	const { t } = useTranslation();
	return (
		<div className="bg-[#1a2531] text-white p-6 rounded-2xl shadow-xl relative overflow-hidden">
			<h4 className="text-[10px] font-black uppercase tracking-widest mb-6 opacity-40">
				{t(
					"mediaReconcile.mediaBatch.accountabilitySignOff",
				)}
			</h4>
			<div className="space-y-6 relative z-10">
				<div className="space-y-2">
					<label className="text-[9px] font-black uppercase text-white/40 block">
						{t(
							"mediaReconcile.mediaBatch.technicianVerification",
						)}
					</label>
					<div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl p-3">
						<span className="material-symbols-outlined text-white/50">
							draw
						</span>
						<span className="text-[11px] font-bold">
							{technicianName}
						</span>
					</div>
				</div>
				<div className="p-4 bg-orange-500/10 border border-orange-500/20 rounded-xl">
					<p className="text-[10px] leading-tight text-orange-200 italic">
						"
						{t(
							"mediaReconcile.mediaBatch.technicianVerificationCertification",
							{ identifier: mediaBatchIdentifier },
						)}
						"
					</p>
				</div>
			</div>
			<div className="absolute -bottom-6 -left-6 text-white/5 pointer-events-none">
				<span className="material-symbols-outlined text-9xl">
					verified_user
				</span>
			</div>
		</div>
	);
};

export default MBTechnicialVerificationCard;
